module.exports = __webpack_public_path__ + "static/media/arrow-landscape.3f613086.svg";